import React, { useEffect } from "react";
import { Field } from "formik";
import l from "components/util/l";

const CheckboxField = ({
  name,
  label,
  value,
  disabled,
  caption,
  defaultValue,
  helpMessage = "",
  setFieldValue
}) => {
  
  useEffect(() => {
    if (value === undefined && defaultValue != null)
      setFieldValue(name, defaultValue)
  }, [value, defaultValue])

  return (
    <div style={{ marginTop: "0.1rem" }}>
      <div class="custom-control custom-switch">
        <Field 
          id={name}
          name={name} 
          type="checkbox" 
          class={"custom-control-input"} 
          checked={value === true}
          onChange={(e) => setFieldValue(name, e.target.checked)}
          disabled={disabled} />

        <label class="custom-control-label input-label" for={name}>
          {label != "" ? <div className="ml-1">
            <span>{l(label)}</span>
            {helpMessage != "" ? <div style={{ fontSize: "0.95em", color: "#90959a" }}>{l(helpMessage)}</div> : null}
          </div> : null}
          {caption != "" ? <div>
            <span style={{ fontSize: "0.9em", color: "#a0a5aa" }}>{l(caption)}</span>
          </div> : null}
        </label>
      </div>
    </div>
  );
}

export default CheckboxField;